import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Layout from "../../components/layout/Layout";
import EmployeeDetailCard from "./components/EmployeeDetailCard";
import EmployeeLeaveAllocationCard from "./components/EmployeeLeaveAllocationCard";
import EmployeeLeaveListView from "./components/LeaveListView";

const EmployeeLeaveView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const queryClient = useQueryClient();

  const handleRefreshLeaves = () => {
    if (id && id !== "undefined") {
      // Invalidate the leave list to refresh the table in EmployeeLeaveListView
      queryClient.invalidateQueries({ queryKey: ["leaveList", id] });

      // Invalidate the balances to refresh the table in EmployeeLeaveAllocationCard
      queryClient.invalidateQueries({
        queryKey: ["employeeLeaveBalances", id],
      });
    }
  };

  return (
    <Layout>
      <div className="container-fluid py-4 px-lg-4">
        <div className="mb-4">
          <button
            type="button"
            className="btn btn-link p-0 text-slate-500 fs-080 text-decoration-none"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left"></i> Back
          </button>
          <h1 className="fw-bold text-dark m-0 page-title">Employee Leave</h1>
          <p className="text-muted small mb-0">
            Balances, allocations and leave history of one employee.
          </p>
        </div>

        <EmployeeDetailCard />
        <EmployeeLeaveAllocationCard id={id} onRefresh={handleRefreshLeaves} />
        <EmployeeLeaveListView id={id} onRefresh={handleRefreshLeaves} />
      </div>
    </Layout>
  );
};

export default EmployeeLeaveView;
